export default __webpack_public_path__ + "images/B3.8f28230.png";